import { render, staticRenderFns } from "./PortItem.vue?vue&type=template&id=d82fbd06&scoped=true&"
import script from "./PortItem.vue?vue&type=script&lang=js&"
export * from "./PortItem.vue?vue&type=script&lang=js&"
import style0 from "./PortItem.vue?vue&type=style&index=0&id=d82fbd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82fbd06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d82fbd06')) {
      api.createRecord('d82fbd06', component.options)
    } else {
      api.reload('d82fbd06', component.options)
    }
    module.hot.accept("./PortItem.vue?vue&type=template&id=d82fbd06&scoped=true&", function () {
      api.rerender('d82fbd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/TabDataTracking/components/PortItem.vue"
export default component.exports